import { EntityReminders } from 'components/EntityReminders';
import { EntityNotes } from 'components/EntityNotes';
import { Icon } from 'components/Icon';
import { classNames, React, useCallback, useState } from 'libs/react';
import './EntityActivity.scss';
/**
 * @component EntityActivity
 * @since 1.0.0
 */
export function EntityActivity(props) {
    const { entity, entityId, variant = 'page' } = props;
    const [activeTab, setActiveTab] = useState('notes');
    const [noteCount, setNoteCount] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);
    const [overdueCount, setOverdueCount] = useState(0);
    const onPendingCountChange = useCallback((count, overdue) => {
        setPendingCount(count);
        setOverdueCount(overdue);
    }, []);
    const tabs = [
        {
            key: 'notes',
            label: t('Notes'),
            picto: 'fal note-sticky',
            count: noteCount,
            alert: false
        },
        {
            key: 'reminders',
            label: t('Reminders'),
            picto: 'fal bell',
            count: pendingCount,
            alert: overdueCount > 0
        }
    ];
    return (React.createElement("div", { className: classNames('entity-activity', 'entity-activity--' + variant, props.className) },
        React.createElement("div", { className: "entity-activity-head" },
            React.createElement("div", { className: "entity-activity-switch", role: "tablist" }, tabs.map((tab) => (React.createElement("button", { key: tab.key, type: "button", role: "tab", "aria-selected": activeTab === tab.key, className: classNames('entity-activity-switch-option', {
                    'entity-activity-switch-option--selected': activeTab === tab.key
                }), onClick: () => setActiveTab(tab.key) },
                React.createElement(Icon, { className: "entity-activity-switch-picto", value: tab.picto }),
                tab.label,
                tab.count > 0 && (React.createElement("span", { className: classNames('entity-activity-switch-count', {
                        'entity-activity-switch-count--alert': tab.alert
                    }), title: tab.alert
                        ? t('{count} overdue').replace('{count}', String(overdueCount))
                        : undefined }, tab.count))))))),
        React.createElement("div", { className: "entity-activity-panel" },
            React.createElement("div", { role: "tabpanel", className: classNames('entity-activity-panel-item', {
                    'entity-activity-panel-hidden': activeTab !== 'notes'
                }) },
                React.createElement(EntityNotes, { entity: entity, entityId: entityId, onCountChange: setNoteCount })),
            React.createElement("div", { role: "tabpanel", className: classNames('entity-activity-panel-item', {
                    'entity-activity-panel-hidden': activeTab !== 'reminders'
                }) },
                React.createElement(EntityReminders, { entity: entity, entityId: entityId, onPendingCountChange: onPendingCountChange })))));
}
